export const belgianPostalCodeLength = 4;
export const frenchPostalCodeLength = 5;
export const germanPostalCodeLength = 5;
